var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sub_menu-lvl3"},[(_vm.info.name == 'Plantillas')?_c('div',{staticClass:"d-flex pl-3"},_vm._l((_vm.filterItems()),function(item,index){return _c('span',{key:index,staticClass:"d-flex align-items-center mb-2"},[_c('span',{staticClass:"i-base i-btn i-btn-sm i-btn-lg my-2",class:{
          'i-cart': item.name == 'ecommerce',
          'i-idea': item.name == 'generica',
          'btn-select-active': _vm.skill_template?.name == item.name,
        },attrs:{"title":item.label},on:{"click":function($event){return _vm.changeTemplate(item)}}}),_c('span',{staticClass:"tooltip_text-sm ml-5"},[_vm._v(_vm._s(item.label))])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }